import OMT_VILLAINS from '../../OMT_UI/OMT_Villains';

const width = 640;
const height = 1242;

const convertToPercentageX = (x) => (x / width) * 100;
const convertToPercentageY = (y) => (y / height) * 100;

const xOffset = 50;
const xOffset2 = xOffset + 10;
const yOffset = 50;

export default [
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_1_1'),
    transforms: [
      {
        x: convertToPercentageX(-88 + xOffset),
        y: convertToPercentageY(37 + yOffset),
        callback: (object) => {
          object.scale.setTo(0.45);
          object.scale.x *= -1;
        },
      },
      {
        x: convertToPercentageX(76 + xOffset),
        y: convertToPercentageY(190 + yOffset),
        duration: 340,
      },
      {
        y: convertToPercentageY(173 + yOffset),
        duration: 100,
      },
      {
        y: convertToPercentageY(164 + yOffset),
        duration: 65,
      },
      {
        wait: 400,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_1_5'));
        },
      },
      {
        wait: 2030,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_1_1'));
        },
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('villain_2_1'),
    transforms: [
      {
        x: convertToPercentageX(743 - xOffset2),
        y: convertToPercentageY(20 + yOffset),
        scale: 0.45,
      },
      {
        x: convertToPercentageX(680 - xOffset2),
        y: convertToPercentageY(0 + yOffset),
        duration: 340,
      },
      {
        x: convertToPercentageX(600 - xOffset2),
        y: convertToPercentageY(130 + yOffset),
        duration: 105,
      },
      {
        x: convertToPercentageX(550 - xOffset),
        y: convertToPercentageY(196 + yOffset),
        duration: 65,
      },
      {
        wait: 330,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_2_4'));
        },
      },
      {
        wait: 1930,
        callback: (object) => {
          object.changeTexture(OMT_VILLAINS.getPrefixedName('villain_2_1'));
        },
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(93),
        y: convertToPercentageY(285),
        scale: 0.36,
      },
      {
        wait: 870,
      },
      {
        alpha: 1,
      },
      {
        angle: 177,
        x: convertToPercentageX(316),
        y: convertToPercentageY(843),
        scale: 1.43,
        duration: 265,
      },
      {
        angle: 165,
        x: convertToPercentageX(321),
        y: convertToPercentageY(851),
        scale: 1.41,
        duration: 70,
      },
      {
        angle: 124,
        x: convertToPercentageX(326),
        y: convertToPercentageY(855),
        scale: 1.33,
        duration: 175,
      },
      {
        alpha: 0,
        duration: 100,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(552),
        y: convertToPercentageY(284),
        scale: 0.35,
      },
      {
        wait: 870,
      },
      {
        alpha: 1,
      },
      {
        angle: 177,
        x: convertToPercentageX(361),
        y: convertToPercentageY(831),
        scale: 1.17,
        duration: 300,
      },
      {
        alpha: 0,
        angle: -107,
        x: convertToPercentageX(321),
        duration: 230,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(355),
        y: convertToPercentageY(905),
        scale: 1.44,
      },
      {
        wait: 1340,
      },
      {
        alpha: 1,
        angle: -28,
        x: convertToPercentageX(346),
        y: convertToPercentageY(520),
        scale: 4,
        duration: 135,
      },
      {
        angle: -55,
        x: convertToPercentageX(322),
        y: convertToPercentageY(390),
        scale: 3.9,
        duration: 130,
      },
      {
        angle: -77,
        x: convertToPercentageX(304),
        y: convertToPercentageY(290),
        scale: 3.8,
        duration: 100,
      },
      {
        alpha: 0,
        angle: -175,
        x: convertToPercentageX(326),
        y: convertToPercentageY(-32),
        scale: 1.04,
        duration: 470,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(174),
        y: convertToPercentageY(651),
      },
      {
        wait: 1770,
      },
      {
        alpha: 1,
        angle: 28,
        x: convertToPercentageX(173),
        y: convertToPercentageY(528),
        scale: 1.1,
        duration: 135,
      },
      {
        alpha: 0,
        angle: 153,
        x: convertToPercentageX(168),
        y: convertToPercentageY(-37),
        scale: 1.65,
        duration: 610,
      },
    ],
  },
  {
    texture: OMT_VILLAINS.getPrefixedName('super_hard_corruption'),
    destroyOnComplete: true,
    landscape: {
      scaleCoeff: {
        scale: 1.2,
      },
    },
    transforms: [
      {
        alpha: 0,
        x: convertToPercentageX(491),
        y: convertToPercentageY(566),
      },
      {
        wait: 1770,
      },
      {
        alpha: 1,
        angle: 16,
        x: convertToPercentageX(490),
        y: convertToPercentageY(510),
        scale: 1.07,
        duration: 65,
      },
      {
        alpha: 0,
        angle: 174,
        x: convertToPercentageX(484),
        y: convertToPercentageY(-81),
        scale: 1.85,
        duration: 635,
      },
    ],
  },
];
